/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-template-curly-in-string */
import React, { useContext, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment-timezone';
import { TemplateTypesType } from '../../../../api/templateTypesApiType';
import ConfigContext from '../../../../contexts/ConfigContext';
import { FormType, ModalFormBaseProps } from '../../../common/types/formTypes';
import TemplateTypesForm, { TemplateTypesFormType } from './TemplateTypesForm';
import { submitTemplateTypesForm } from './templateTypesFormHelper';
import NinModal from '../../../common/modal/NinModal';

export interface TemplateTypesModalProps extends ModalFormBaseProps {
    templateType?: TemplateTypesType;
}

const TemplateTypesModal = (props: TemplateTypesModalProps) => {
    const config = useContext(ConfigContext);
    const [responseError, setResponseError] = useState('');

    const templateTypesValidationSchema = Yup.object().shape({
        name: Yup.string()
            .required('Name is required')
            .max(100, 'Name exceeds max length of ${max} characters')
            .matches(
                /^[\x20-\x7F]*$/,
                'Name must consist of only ASCII characters (check for MS Word hyphenation)',
            ),
        description: Yup.string()
            .required('Description is required')
            .max(200, 'Description exceeds max length of ${max} characters')
            .matches(
                /^[\x20-\x7F]*$/,
                'Description must consist of only ASCII characters (check for MS Word hyphenation)',
            ),
        startDate: Yup.date().required('Start Date is required'),
        endDate: Yup.date()
            .nullable()
            .test('after-check', 'End Date must not be before Start Date', function test(endDate) {
                if (!endDate) {
                    return true;
                }
                const startMoment = moment(this.parent.startDate);
                const endMoment = moment(endDate);
                return !endMoment.isBefore(startMoment);
            }),
    });

    let templateTypeName: string = '';
    let templateTypeDescription: string = '';
    if (props.templateType) {
        // Copy name
        if (props.formType === FormType.CLONE) {
            templateTypeName = `COPY OF ${props.templateType.name}`.substr(0, 100);
        } else {
            templateTypeName = props.templateType.name;
        }

        // Copy description
        if (props.templateType.description && props.formType === FormType.CLONE) {
            templateTypeDescription = `COPY OF ${props.templateType.description}`.substr(0, 200);
        } else {
            templateTypeDescription = props.templateType.description || '';
        }
    }

    const initialValues: TemplateTypesFormType = {
        id: props.templateType ? props.templateType.id : undefined,
        name: templateTypeName,
        description: templateTypeDescription,
        startDate: props.templateType ? props.templateType.startDate : new Date().toISOString(),
        endDate: props.templateType && props.templateType.endDate ? props.templateType.endDate : '',
        active: props.templateType ? props.templateType.active : true,
    };

    return (
        <NinModal
            button={props.toggleButton}
            size="lg"
            render={(toggleModal: () => void) => (
                <Formik
                    initialValues={initialValues}
                    validationSchema={templateTypesValidationSchema}
                    onSubmit={async (values, { resetForm, setSubmitting }) => {
                        const submitSuccessful = await submitTemplateTypesForm(
                            config,
                            props.formType,
                            values,
                            setResponseError,
                            resetForm,
                            setSubmitting,
                            toggleModal,
                        );
                        if (props.onSubmit && submitSuccessful) {
                            setResponseError('');
                            props.onSubmit();
                        }
                    }}
                    render={(formikProps) => (
                        <TemplateTypesForm
                            {...formikProps}
                            formType={props.formType}
                            responseError={responseError}
                            setResponseError={setResponseError}
                            toggleModal={toggleModal}
                        />
                    )}
                />
            )}
        />
    );
};

export default TemplateTypesModal;
